import { render, staticRenderFns } from "./AsistenciaView.vue?vue&type=template&id=4c2a0b20&"
import script from "./AsistenciaView.vue?vue&type=script&lang=js&"
export * from "./AsistenciaView.vue?vue&type=script&lang=js&"
import style0 from "./AsistenciaView.vue?vue&type=style&index=0&id=4c2a0b20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports